<template>
  <section>
    <VerReporte />
    <VerMarcados/>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-card>
      <v-card-title class="headline m-0">
        <h3>
          <v-icon>today</v-icon>Procesamiento de control de asistencia -
          Pasantes
        </h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card>
        <MonitoreoTipificacion />
      </v-card>
      <v-card-text>

        <!-- Cuerpo del formulario -->
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text class="p-0">
            <v-container class="p-0" grid-list-md style="min-width: 100%">
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    type="date"
                    v-model="form.fecha_inicio"
                    label="Fecha inicio"
                    @input="obtenerListaFuncionarios()"
                    :rules="$validate(['required'])"
                    required
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    type="date"
                    v-model="form.fecha_fin"
                    label="Fecha fin"
                    @input="obtenerListaFuncionarios()"
                    :rules="$validate(['required'])"
                    required
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>

                <v-flex md6 xs12>
                  <v-text-field
                    v-model="form.paterno"
                    label="Paterno"
                    @input="filtraFuncionarios()"
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="form.materno"
                    label="Materno"
                    @input="filtraFuncionarios()"
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="form.nombres"
                    label="Nombres"
                    @input="filtraFuncionarios()"
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>

                <v-flex md6 xs12>
                  <v-text-field
                    v-model="form.ci"
                    label="Cédula de identidad"
                    @input="filtraFuncionarios()"
                    class="text-field-reducido-border"
                    outline
                    clearable
                  />
                </v-flex>

                <v-flex xs12 class="layout">
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="rgba(31,14,180,0.3)"
                    @click="filtraFuncionarios()"
                    type="submit"
                  >
                    <v-icon>search</v-icon>
                    Buscar
                  </v-btn>
                  <v-btn
                    color="rgba(158,11,127,0.6)"
                    @click="limpiarCampos()"
                    type="submit"
                  >
                    <v-icon>redo</v-icon>
                    Limpiar
                  </v-btn>
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="rgba(31,14,180,0.3)"
                    @click="verReporte(form,1,'pdf')"
                    type="submit"
                  >
                    <v-icon>picture_as_pdf</v-icon>
                    Ver reporte Pasantes PDF
                  </v-btn>
                  <v-btn
                    :disabled="!bandera_boton_buscar"
                    color="green"
                    @click="verReporte(form,1,'xls')"
                    type="submit"
                  >
                  <span class="material-symbols-outlined">
                table
              </span>
              Ver reporte Pasantes EXCEL
                  </v-btn>
                  <!-- <span>Imprimir reporte excel</span> -->
                </v-flex>
                <v-flex xs12 class="py-0 m-0">
                  <v-btn
                    class="mx-0 my-1"
                    color="rgb(64,79,191)"
                    block
                    @click="tipificar()"
                    :loading="loading"
                    :disabled="
                      !form.fecha_inicio ||
                        !form.fecha_fin ||
                        (!form.fecha_inicio && !form.fecha_fin)
                    "
                    dark
                    title="Procesar pasantes"
                  >
                    <v-icon>schedule</v-icon>
                    PROCESAR PASANTES
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-form>
        <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="lista_filtrada_funcionarios"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :loading="loading"
          item-key="index"
          rows-per-page-text="Filas por pagina"
          :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 20, 50, { value: -1, text: 'Todos' }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                id="cabecera_tabla"
                class="header-comprmido"
                @click="changeSort(header.value)"
              >
                <v-icon v-if="header.value" small color="white"
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-center py-0 px-1">
              <v-avatar
                :color="props.item.foto ? '#FFF' : 'light-blue darken-4'"
              >
                <img
                  v-if="props.item.foto"
                  :src="url_backend + props.item.foto"
                  :alt="props.item.nombres[0]"
                  style="border: 1px solid #7BAFD4 !important;"
                  @error="handleImageError(props.item)"
                />
                <span v-else class="white--text headline">{{
                  props.item.nombres[0] || "-"
                }}</span>
              </v-avatar>
            </td>

            <td class="text-xs-center">
              {{ props.item.ap_paterno }} {{ props.item.ap_materno }}
              {{ props.item.nombres }}
            </td>
            <td class="text-xs-center">
              {{ props.item.nro_doc }}
            </td>

            <td class="text-xs-center">
              {{ props.item.dependencia }}
            </td>

            <td class="text-xs-center">
              <v-btn
                color="blue"
                outline
                @click.prevent="tipificarPorPersona(props.item)"
                icon
                title="Tipificar"
                :loading="props.item.loading == true"
              >
                <v-icon>update</v-icon>
              </v-btn>
              <v-btn
                color="rgb(107,89,166)"
                outline
                @click.prevent="verMarcados(props.item)"
                icon
                title="Ver marcados"
              >
                <v-icon>schedule</v-icon>
              </v-btn>
              <v-btn
                color="orange"
                outline
                @click.prevent="verReporte(props.item,2,'pdf')"
                icon
                title="Ver reporte de asistencias PDF"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

              <v-btn
                color="green"
                outline
                @click.prevent="verReporte(props.item,2,'xls')"
                icon
                title="Ver reporte de asistencias EXCEL"
              >
              <span class="material-symbols-outlined">
                table
              </span>
              </v-btn>

            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate";
import MonitoreoTipificacion from "./components/MonitoreoTipificacion.vue";
import VerReporte from "./dialogs/VerReporte.vue";
import VerMarcados from "./dialogs/VerMarcados.vue";
export default {
  // Definición de componentes importados
  components: { MonitoreoTipificacion, VerReporte ,VerMarcados},
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  mixins: [validate],
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      form: {},
      valid: false,
      validated: 0,
      loading: false,

      headers: [
        {
          text: "",
          value: "",
          align: "center"
        },
        {
          text: "Nombre completo",
          value: "nombres",
          align: "center"
        },
        {
          text: "Cédula de identidad",
          value: "ap_paterno",
          align: "center"
        },

        {
          text: "Dependencia",
          value: "dependencia",
          align: "center"
        },

        { text: this.$t("common.actions"), sortable: false }
      ],
      unidades_especificas: [],
      lista_funcionarios: [],
      bandera_boton_buscar: true,
      lista_filtrada_funcionarios: [],
      user: this.$storage.get("user"),
      url_backend: process.env.API_URL.split("api/")[0]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [128];
    if (!this.$util.permisoRol(rolesPermitidos)) {
      if (this.$route.params.id != null) {
        // await this.logoutUser()
        this.$router.push("/accion-no-permitida");
      }
    }

    var date = new Date();
    let primer_dia_mes = new Date(date.getFullYear(), date.getMonth(), 1);
    primer_dia_mes = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
    let ultimo_dia_año = this.$moment().format("YYYY-MM-DD");
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    this.form.fecha_inicio = primer_dia_mes;
    this.form.fecha_fin = ultimo_dia_año;
    await this.obtenerListaFuncionarios();
  },
  // Métodos y funciones del componente
  methods: {
    verReporte(item,valor,formato) {
      let nombre_reporte="rpt_asistencia_general_pasante"
      let url =""
      if (valor==2) {
        url = this.$util.getUrlReporte(
        "marcados",
        nombre_reporte,
        formato,
        {
          P_FECHA_INICIO: this.form.fecha_inicio,
          P_FECHA_FIN: this.form.fecha_fin,
          P_ID_PERSONA: item.id_persona,
          P_ID_USUARIO: this.user.id
        }
      );
      } else {
        nombre_reporte="rpt_asistencia_general_marcados_pasantes";
        url = this.$util.getUrlReporte(
        "marcados",
        nombre_reporte,
        formato,
        {
          P_FECHA_DESDE: this.form.fecha_inicio,
          P_FECHA_HASTA: this.form.fecha_fin,
          P_AP_PATERNO: this.form.paterno,
          P_AP_MATERNO: this.form.materno,
          P_NOMBRES: this.form.nombres,
          P_NRO_DOC: this.form.ci,
          P_ID_USUARIO: this.user.id,
        }
      );
      }
      this.$bus.$emit("openDialogVerReporte", url);
    },
    verMarcados(item) {
      this.$bus.$emit("openDialogVerMarcadosPasante", item);
    },
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para verificar si ocurrio un error al cargar la imagen
    handleImageError(item) {
      item.foto = "";
    },
    // Metodo que filtra la lista de funcionarios
    filtraFuncionarios() {
      if (!this.form.materno) {
        this.form.materno = "";
      }
      if (!this.form.paterno) {
        this.form.paterno = "";
      }
      if (!this.form.nombres) {
        this.form.nombres = "";
      }
      if (!this.form.ci) {
        this.form.ci = "";
      }
      if (!this.form.item) {
        this.form.item = "";
      }
      this.lista_filtrada_funcionarios = this.lista_funcionarios.filter(
        persona =>
          (persona.ap_paterno ? persona.ap_paterno : "")
            .toUpperCase()
            .indexOf(this.form.paterno.toUpperCase()) != -1 &&
          (persona.ap_materno ? persona.ap_materno : "")
            .toUpperCase()
            .indexOf(this.form.materno.toUpperCase()) != -1 &&
          (persona.nombres ? persona.nombres : "")
            .toUpperCase()
            .indexOf(this.form.nombres.toUpperCase()) != -1 &&
          (persona.nro_doc ? persona.nro_doc : "")
            .toUpperCase()
            .indexOf(this.form.ci.toUpperCase()) != -1
      );
    },

    async tipificarPorPersona(item) {
      if (!this.form.fecha_inicio) {
        this.$message.info("Ingrese fecha desde");
        return;
      }
      if (!this.form.fecha_fin) {
        this.$message.info("Ingrese fecha hasta");
        return;
      }
      if (this.$refs.form.validate()) {
        try {
          item.loading = true;
          var id_persona = parseInt(item.id_persona);

          let rpta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT planilla.fn_tipifica_por_rango_de_fechas_pasante(${id_persona},'${this.form.fecha_inicio}','${this.form.fecha_fin}')"){
                  respuesta
                }
              }
            `
          });
          if (
            rpta.runQuery.respuesta[0]
              .fn_tipifica_por_rango_de_fechas_por_persona
          ) {
            let res = rpta.runQuery.respuesta[0].fn_tipifica_por_rango_de_fechas_pasante.split(
              "|"
            );
            if (res[0] == "1") {
              this.$message.success("Tipificación exitosa");
            } else {
              this.$message.warning(res[1]);
            }
          }
          item.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async tipificar() {
      if (this.$refs.form.validate()) {
        if (!this.form.fecha_inicio) {
          this.$message.info("Ingrese fecha desde");
          return;
        }
        if (!this.form.fecha_fin) {
          this.$message.info("Ingrese fecha hasta");
          return;
        }
        this.$confirm(
          `¿Está seguro de procesar el control de asistencia de todos los pasantes de fecha ${this.$moment(
            this.form.fecha_inicio
          ).format("DD/MM/YYYY")} a ${this.$moment(this.form.fecha_fin).format(
            "DD/MM/YYYY"
          )}?`,
          async () => {
            this.loading = true;
            try {
              let res = await this.$service.graphql({
                query: `
								 mutation edit($tipificacion: Tipificacion!){
                  tipificaTotalPasantes(tipificacion: $tipificacion){
                  mensaje
                  }
                  }
							`,
                variables: {
                  tipificacion: {
                    fecha_inicio: this.form.fecha_inicio,
                    fecha_fin: this.form.fecha_fin,
                    id_usuario: this.user.id
                  }
                }
              });
              this.$message.info(res.tipificaTotalPasantes.mensaje);
              this.loading = false;
            } catch (error) {
              console.log(error);
            }
          }
        );
      }
    },
    async obtenerListaFuncionarios() {
      try {
        this.bandera_boton_buscar = true;
        if (this.form.fecha_inicio && this.form.fecha_fin) {
          this.lista_funcionarios = [];
          this.lista_filtrada_funcionarios = [];
          var query = `select * from planilla.fn_lista_pasantes_tipificacion('${this.form.fecha_inicio}','${this.form.fecha_fin}') as (id_persona integer,ap_paterno varchar,ap_materno varchar,nombres varchar, nro_doc varchar,nro_complemento varchar, nro_item varchar, dependencia varchar, foto varchar,id_tipo_justificacion integer,fecha_incorporacion date,fecha_retiro date, id_unidad integer,nombre_unidad varchar)`;
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"${query}"){
                  respuesta
                }
              }
            `
          });
          if (res.runQuery.respuesta.length != 0) {
            var lista_tmp = res.runQuery.respuesta;
            // Asignamos un loading por cada fila
            lista_tmp.forEach(element => {
              element.loading = false;
            });
            this.lista_funcionarios = lista_tmp;
            this.filtraFuncionarios();
          }
        } else {
          this.bandera_boton_buscar = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.bandera_boton_buscar = false;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/pasantes/AsistenciaTipificacion.vue